import React from "react";
import { CustomText } from "../../components";

import { alerts, hooks } from "../../utils";

import { CircularProgress } from "@mui/material";
import { HomeWork } from "@mui/icons-material";
import { errorModal } from "../../components/modals/utils";
import { api } from "../../services";

import { StylesForm } from "./styles";

import RenterForm from "./components/RenterForm";

function Renter() {
  const { loading, call } = hooks.useRequest();

  const [success, setSuccess] = React.useState<any>(false);

  const onSubmit = (formData) => {
    const submitCallback = () => {
      errorModal.close();
      call(null, api.putRenterData(formData), (response) => {
        if (response.ok) {
          setSuccess(true);
        }
      });
    };

    alerts.setErrorModal(
      "Confirmação de Dados de Acesso",
      [
        "Ao continuar, você confirma os seus dados de acesso. Deseja continuar?",
      ],
      HomeWork,
      [
        {
          label: "Sim, Confirmar",
          onClick: submitCallback,
        },
        {
          label: "Voltar",
          onClick: () => {
            errorModal.close();
          },
        },
      ]
    );
  };

  return (
    <>
      {loading ? (
        <StylesForm.ContainerExtra>
          <CircularProgress />
        </StylesForm.ContainerExtra>
      ) : success ? (
        <StylesForm.ContainerExtra>
          <CustomText fontSize={3}>Dados enviados com sucesso! 😊</CustomText>
        </StylesForm.ContainerExtra>
      ) : (
        <RenterForm onSubmit={onSubmit} />
      )}
    </>
  );
}

export default Renter;
